// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Formality from "../../../../../../../node_modules/re-formality/src/Formality.bs.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Row$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as UserProfileType from "../../../app/entity/UserProfileType.bs.js";
import * as FormInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as FormHelper$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as Formality__ReactUpdate from "../../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.bs.js";
import * as FormSingleCheckBoxInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormSingleCheckBoxInput.bs.js";

var validators = {
  secondary_mobile_number: undefined,
  primary_mobile_number: undefined
};

function initialFieldsStatuses(_input) {
  return {
          secondary_mobile_number: /* Pristine */0,
          primary_mobile_number: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            secondary_mobile_number: /* Pristine */0,
            primary_mobile_number: /* Pristine */0
          },
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, param, param$1) {
  var match_0 = {
    TAG: /* Ok */0,
    _0: input.secondary_mobile_number
  };
  var match_0$1 = {
    TAG: /* Ok */0,
    _0: input.primary_mobile_number
  };
  var secondary_mobile_numberResult = match_0;
  var secondary_mobile_numberResult$1;
  if (secondary_mobile_numberResult.TAG === /* Ok */0) {
    var primary_mobile_numberResult = match_0$1;
    if (primary_mobile_numberResult.TAG === /* Ok */0) {
      return {
              TAG: /* Valid */0,
              output: {
                primary_mobile_number: primary_mobile_numberResult._0,
                secondary_mobile_number: secondary_mobile_numberResult._0
              },
              fieldsStatuses: {
                secondary_mobile_number: /* Dirty */{
                  _0: secondary_mobile_numberResult,
                  _1: /* Hidden */1
                },
                primary_mobile_number: /* Dirty */{
                  _0: primary_mobile_numberResult,
                  _1: /* Hidden */1
                }
              },
              collectionsStatuses: undefined
            };
    }
    secondary_mobile_numberResult$1 = secondary_mobile_numberResult;
  } else {
    secondary_mobile_numberResult$1 = secondary_mobile_numberResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            secondary_mobile_number: /* Dirty */{
              _0: secondary_mobile_numberResult$1,
              _1: /* Hidden */1
            },
            primary_mobile_number: /* Dirty */{
              _0: match_0$1,
              _1: /* Hidden */1
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurSecondary_mobile_numberField */0 :
                  var result = Formality.validateFieldOnBlurWithoutValidator(state.input.secondary_mobile_number, state.fieldsStatuses.secondary_mobile_number, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  secondary_mobile_number: status,
                                  primary_mobile_number: init.primary_mobile_number
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurPrimary_mobile_numberField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithoutValidator(state.input.primary_mobile_number, state.fieldsStatuses.primary_mobile_number, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  secondary_mobile_number: init.secondary_mobile_number,
                                  primary_mobile_number: status
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */2 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */2,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */3,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */5);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */4);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */3 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */4 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */5 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateSecondary_mobile_numberField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput.secondary_mobile_number, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            secondary_mobile_number: status,
                                            primary_mobile_number: init.primary_mobile_number
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdatePrimary_mobile_numberField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$1.primary_mobile_number, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            secondary_mobile_number: init.secondary_mobile_number,
                                            primary_mobile_number: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */2 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                secondary_mobile_number: /* Pristine */0,
                                primary_mobile_number: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                secondary_mobile_number: /* Pristine */0,
                                primary_mobile_number: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */3 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */4 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateSecondary_mobile_number: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateSecondary_mobile_numberField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updatePrimary_mobile_number: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdatePrimary_mobile_numberField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurSecondary_mobile_number: (function (param) {
              return Curry._1(dispatch, /* BlurSecondary_mobile_numberField */0);
            }),
          blurPrimary_mobile_number: (function (param) {
              return Curry._1(dispatch, /* BlurPrimary_mobile_numberField */1);
            }),
          secondary_mobile_numberResult: Formality.exposeFieldResult(state.fieldsStatuses.secondary_mobile_number),
          primary_mobile_numberResult: Formality.exposeFieldResult(state.fieldsStatuses.primary_mobile_number),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.secondary_mobile_number || match.primary_mobile_number) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */2);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */3);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */4);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */4,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */5);
            })
        };
}

var CheckBoxForm = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function SmsUserProfileDetailsCmp$MobileNumberCheckBox(Props) {
  var user_data = Props.user_data;
  var form = Props.form;
  var secondaryMobileNumber = user_data.secondary_mobile_number;
  var tmp;
  tmp = secondaryMobileNumber !== undefined && secondaryMobileNumber !== "N/A" ? React.createElement("div", {
          className: "w-50 mobile-checkbox ml-1 " + (
            form.input.secondary_mobile_number ? "selected-mobile-checkbox" : ""
          )
        }, React.createElement(Row$Catalyst.make, {
              children: null
            }, React.createElement(FormSingleCheckBoxInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                          return Curry._2(form.updateSecondary_mobile_number, (function (input, value) {
                                        return {
                                                primary_mobile_number: input.primary_mobile_number,
                                                secondary_mobile_number: value
                                              };
                                      }), FormHelper$Catalyst.TargetEventWrapper.checked($$event));
                        }), undefined, undefined, undefined, undefined, undefined, undefined, form.secondary_mobile_numberResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  checked: form.input.secondary_mobile_number,
                  label: ""
                }), React.createElement("div", undefined, React.createElement("div", {
                      className: "mobile-number"
                    }, secondaryMobileNumber), React.createElement("span", {
                      className: "mobile-number-type mobile-number-secondary-type"
                    }, "Secondary")))) : null;
  return React.createElement(Row$Catalyst.make, {
              children: null,
              className: "w-full"
            }, React.createElement("div", {
                  className: "w-50 mobile-checkbox " + (
                    form.input.primary_mobile_number ? "selected-mobile-checkbox" : ""
                  )
                }, React.createElement(Row$Catalyst.make, {
                      children: null
                    }, React.createElement(FormSingleCheckBoxInput$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                  return Curry._2(form.updatePrimary_mobile_number, (function (input, value) {
                                                return {
                                                        primary_mobile_number: value,
                                                        secondary_mobile_number: input.secondary_mobile_number
                                                      };
                                              }), FormHelper$Catalyst.TargetEventWrapper.checked($$event));
                                }), undefined, undefined, undefined, undefined, undefined, undefined, form.primary_mobile_numberResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                          checked: form.input.primary_mobile_number,
                          label: ""
                        }), React.createElement("div", undefined, React.createElement("div", {
                              className: "mobile-number"
                            }, user_data.primary_mobile_number), React.createElement("span", {
                              className: "mobile-number-type"
                            }, "Primary")))), tmp);
}

var MobileNumberCheckBox = {
  make: SmsUserProfileDetailsCmp$MobileNumberCheckBox
};

function SmsUserProfileDetailsCmp(Props) {
  var user_data = Props.user_data;
  var form = Props.form;
  var getCardProfileTagCss = function (profile) {
    var match = UserProfileType.fromString(profile);
    if (match !== 1) {
      if (match >= 4) {
        return "user__unverified";
      } else {
        return "";
      }
    } else {
      return "user__partner";
    }
  };
  if (user_data !== undefined) {
    return React.createElement("div", {
                className: "user"
              }, React.createElement(Row$Catalyst.make, {
                    children: null
                  }, React.createElement("div", {
                        className: "user__name"
                      }, user_data.name), React.createElement("div", {
                        className: "user__type " + getCardProfileTagCss(user_data.profile)
                      }, UserProfileType.displayString(user_data.profile))), React.createElement(Row$Catalyst.make, {
                    children: React.createElement(SmsUserProfileDetailsCmp$MobileNumberCheckBox, {
                          user_data: user_data,
                          form: form
                        }),
                    className: "w-full mt-2 mb-2"
                  }));
  } else {
    return null;
  }
}

var make = SmsUserProfileDetailsCmp;

export {
  CheckBoxForm ,
  MobileNumberCheckBox ,
  make ,
  
}
/* react Not a pure module */
